module.exports = __webpack_public_path__ + "img/nursery.7088462c.svg";